import { render, staticRenderFns } from "./Voluntarios.vue?vue&type=template&id=3c2a61d4"
import script from "./Voluntarios.vue?vue&type=script&lang=js"
export * from "./Voluntarios.vue?vue&type=script&lang=js"
import style0 from "./Voluntarios.vue?vue&type=style&index=0&id=3c2a61d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports